var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ safari: _vm.iOS, invert: _vm.invert },attrs:{"id":"app"}},[_vm._t("header"),_vm._t("default",function(){return [_c('main',{staticClass:"loading"},[_vm._v("Loading…")])]}),_vm._t("footer"),(_vm.$store.state.showChannels)?_c('channels-modal'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }